import React from 'react';
import { BenefitsListPage } from '../@types/benefitsListPage';
import { useGetSchufaStatus } from '../apiHooks/solvencyStatus.hook';
import { useGetBenefitsListPage } from './useGetBenefitsListPage.hook';

export const useGetBenefitListError = () => {
  const { isSchufaStatusError } = useGetSchufaStatus();
  const benefitsListPage = useGetBenefitsListPage();

  return React.useMemo(() => {
    //@todo add conditions for kauferplus and mieterplus
    switch (benefitsListPage) {
      case BenefitsListPage.MieterPlus:
        return isSchufaStatusError;
      default:
        return false;
    }
  }, [benefitsListPage, isSchufaStatusError]);
};
